// extracted by mini-css-extract-plugin
export default {"pageContainer":"aboutUs_pageContainer__EvACg","headerContainer":"aboutUs_headerContainer__XbPNU","card":"aboutUs_card__ivvD2","wenbitLogo":"aboutUs_wenbitLogo__t+DQl"};